import { createAuthClient } from "better-auth/react";
import { emailOTPClient, magicLinkClient, organizationClient } from "better-auth/client/plugins";
import { ac, roles } from "./permissions";

/**
 * Better Auth in the dashboard (worker/src/betterauth.js): organizations (roles), email link and 6-digit code sign-in
 * (screenshots/93–97, §6 ticket 24). Passkeys need the `@better-auth/passkey` package (not installed yet): see
 * auth/authApi.ts.
 */
export const authClient = createAuthClient({
  plugins: [organizationClient({ ac, roles }), magicLinkClient(), emailOTPClient()],
});
